import React from 'react';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { ExhibitionistSlideFitMode } from '../ExhibitionistConfigPopover/types';
import DeviationSlideshow from './DeviationSlideshow';
const ExhibitionistSlideshow = ({ moduleId })=>{
    const { moduleData } = useModuleData(moduleId);
    const { deviations, slideImageFit } = moduleData;
    return /*#__PURE__*/ React.createElement(DeviationSlideshow, {
        items: deviations,
        useCoverMode: slideImageFit === ExhibitionistSlideFitMode.COVER
    });
};
ExhibitionistSlideshow.displayName = 'ExhibitionistSlideshow';
export default ExhibitionistSlideshow;
